import { render, staticRenderFns } from "./StateroomDetail.vue?vue&type=template&id=93879120&scoped=true"
import script from "./StateroomDetail.vue?vue&type=script&lang=js"
export * from "./StateroomDetail.vue?vue&type=script&lang=js"
import style0 from "./StateroomDetail.vue?vue&type=style&index=0&id=93879120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93879120",
  null
  
)

export default component.exports